import api from './api';

export const createMaterialRequest = async (requestData) => {
  try {
    const response = await api.post('/verve-material-requests', requestData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMaterialRequestByLeadId = async (leadId) => {
  try {
    const response = await api.get(`/verve-material-requests/lead/${leadId}`);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null;
    }
    throw error;
  }
};
